import { View, Text } from 'react-native';

type BadgeVariant = 'green' | 'red' | 'blue' | 'yellow' | 'gray' | 'purple';

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
}

const VARIANT_CLASSES: Record<BadgeVariant, { bg: string; text: string }> = {
  green: { bg: 'bg-green-100 dark:bg-green-900/40', text: 'text-green-700 dark:text-green-400' },
  red: { bg: 'bg-red-100 dark:bg-red-900/40', text: 'text-red-700 dark:text-red-400' },
  blue: { bg: 'bg-blue-100 dark:bg-blue-900/40', text: 'text-blue-700 dark:text-blue-400' },
  yellow: { bg: 'bg-yellow-100 dark:bg-yellow-900/40', text: 'text-yellow-700 dark:text-yellow-400' },
  gray: { bg: 'bg-gray-100 dark:bg-gray-700', text: 'text-gray-600 dark:text-gray-300' },
  purple: { bg: 'bg-purple-100 dark:bg-purple-900/40', text: 'text-purple-700 dark:text-purple-400' },
};

export function Badge({ label, variant = 'gray' }: BadgeProps) {
  return (
    <View className={`px-2 py-0.5 rounded-full ${VARIANT_CLASSES[variant].bg}`}>
      <Text className={`text-xs font-medium ${VARIANT_CLASSES[variant].text}`}>
        {label}
      </Text>
    </View>
  );
}
